import React, { FC } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import ActionButtonsContainer from '../actionButtons/ActionButtonsContainer';
import customiseMobileActionsStyles from './customiseMobileActionsStyles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';
import useSalesEnablementContext from '../../../../gqlCommon/hooks/useSalesEnablementContext';

const CustomiseMobileActions: FC = () => {
  const { loading, error } = useCustomizeCarContext();
  const styles = customiseMobileActionsStyles();
  const { breakpoints } = useTheme<ISpcTheme>();
  const displayActionButtons = useMediaQuery(breakpoints.down('sm'));
  const { isInSalesEnablement } = useSalesEnablementContext();

  if (!displayActionButtons || isInSalesEnablement) {
    return null;
  }

  return (
    <>
      <Box className={styles.actionButtonsContainer} data-test={'container:actions'}>
        <ActionButtonsContainer disabled={!!error || loading} />
      </Box>
    </>
  );
};

export default CustomiseMobileActions;
